export const servicesData = [

  // 🧹 CLEANING & PEST CONTROL
  {
    category: "Cleaning & Pest Control",
    slug: "cleaning",
    services: [
      { name: "Full Home Deep Cleaning", image: "/images/services/cleaning/full-home-deep-cleaning.webp" },
      { name: "Kitchen Deep Cleaning", image: "/images/services/cleaning/kitchen-deep-cleaning.webp" },
      { name: "Bathroom Cleaning", image: "/images/services/cleaning/bathroom-cleaning.webp" },
      { name: "Sofa Cleaning", image: "/images/services/cleaning/sofa-cleaning.webp" },
      { name: "Carpet Cleaning", image: "/images/services/cleaning/carpet-cleaning.webp" },
      { name: "Mattress Cleaning", image: "/images/services/cleaning/mattress-cleaning.webp" },
      { name: "Curtain Cleaning", image: "/images/services/cleaning/curtain-cleaning.webp" },
      { name: "Water Tank Cleaning", image: "/images/services/cleaning/water-tank-cleaning.webp" },
      { name: "Move-in / Move-out Cleaning", image: "/images/services/cleaning/move-in-move-out-cleaning.webp" },
      { name: "Post Construction Cleaning", image: "/images/services/cleaning/post-construction-cleaning.webp" },
      { name: "Pest Control Service", image: "/images/services/cleaning/pest-control-service.webp" },
      { name: "Sanitization Services", image: "/images/services/cleaning/sanitization-services.webp" }
    ],
  },

  // 🔧 ELECTRONICS REPAIR & SERVICES
  {
    category: "Electronics Repair & Services",
    slug: "electronics",
    services: [
      { name: "AC Repair & Installation", image: "/images/services/electronics/ac-repair-installation.webp" },
      { name: "Refrigerator Repair", image: "/images/services/electronics/refrigerator-repair.webp" },
      { name: "Washing Machine Repair", image: "/images/services/electronics/washing-machine-repair.webp" },
      { name: "Microwave Repair", image: "/images/services/electronics/microwave-repair.webp" },
      { name: "TV Repair", image: "/images/services/electronics/tv-repair.webp" },
      { name: "Geyser Repair", image: "/images/services/electronics/geyser-repair.webp" },
      { name: "Chimney Repair", image: "/images/services/electronics/chimney-repair.webp" },
      { name: "RO Water Purifier Service", image: "/images/services/electronics/ro-water-purifier-service.webp" },
      { name: "Dishwasher Repair", image: "/images/services/electronics/dishwasher-repair.webp" },
      { name: "Laptop Repair", image: "/images/services/electronics/laptop-repair.webp" },
      { name: "WiFi Setup Service", image: "/images/services/electronics/wifi-setup-service.webp" },
      { name: "CCTV Installation", image: "/images/services/electronics/cctv-installation.webp" }
    ],
  },

  // 🏠 HOME RENOVATION & REPAIR
  {
    category: "Home Renovation & Repair",
    slug: "renovation",
    services: [
      { name: "Electrician Service", image: "/images/services/renovation/electrician-service.webp" },
      { name: "Switch & Socket Repair", image: "/images/services/renovation/switch-socket-repair.webp" },
      { name: "Fan Installation", image: "/images/services/renovation/fan-installation.webp" },
      { name: "Light Installation", image: "/images/services/renovation/light-installation.webp" },
      { name: "Wiring Work", image: "/images/services/renovation/wiring-work.webp" },
      { name: "Plumber Service", image: "/images/services/renovation/plumber-service.webp" },
      { name: "Tap Repair", image: "/images/services/renovation/tap-repair.webp" },
      { name: "Leakage Fixing", image: "/images/services/renovation/leakage-fixing.webp" },
      { name: "Carpenter Service", image: "/images/services/renovation/carpenter-service.webp" },
      { name: "Furniture Repair", image: "/images/services/renovation/furniture-repair.webp" },
      { name: "Interior Painting", image: "/images/services/renovation/interior-painting.webp" },
      { name: "Exterior Painting", image: "/images/services/renovation/exterior-painting.webp" },
      { name: "Waterproofing Service", image: "/images/services/renovation/waterproofing-service.webp" },
      { name: "False Ceiling Work", image: "/images/services/renovation/false-ceiling-work.webp" },
      { name: "Tile Work", image: "/images/services/renovation/tile-work.webp" }
    ],
  },

  // 💄 HEALTH & BEAUTY
  {
    category: "Health & Beauty",
    slug: "beauty",
    services: [
      { name: "Haircut at Home", image: "/images/services/beauty/haircut-at-home.webp" },
      { name: "Hair Coloring", image: "/images/services/beauty/hair-coloring.webp" },
      { name: "Facial & Cleanup", image: "/images/services/beauty/facial-cleanup.webp" },
      { name: "Waxing at Home", image: "/images/services/beauty/waxing-at-home.webp" },
      { name: "Manicure & Pedicure", image: "/images/services/beauty/manicure-pedicure.webp" },
      { name: "Bridal Makeup", image: "/images/services/beauty/bridal-makeup.webp" },
      { name: "Bridal Mehendi", image: "/images/services/beauty/bridal-mehendi.webp" },
      { name: "Party Makeup", image: "/images/services/beauty/party-makeup.webp" },
      { name: "Head Massage", image: "/images/services/beauty/head-massage.webp" },
      { name: "Body Massage", image: "/images/services/beauty/body-massage.webp" },
      { name: "Home Spa Packages", image: "/images/services/beauty/home-spa-packages.webp" },
      { name: "Physiotherapy at Home", image: "/images/services/beauty/physiotherapy-at-home.webp" },
      { name: "Yoga Trainer at Home", image: "/images/services/beauty/yoga-trainer-at-home.webp" }
    ],
  },

  // 🚚 PACKERS & MOVERS
  {
    category: "Packers & Movers",
    slug: "movers",
    services: [
      { name: "Local Shifting Service", image: "/images/services/movers/local-shifting-service.webp" },
      { name: "Packers & Movers", image: "/images/services/movers/packers-movers.webp" },
      { name: "Office Shifting", image: "/images/services/movers/office-shifting.webp" },
      { name: "Loading & Unloading Service", image: "/images/services/movers/loading-unloading-service.webp" }
    ],
  },

  // 🎓 EDUCATION & CLASSES
  {
    category: "Education & Classes",
    slug: "education",
    services: [
      { name: "Home Tutor", image: "/images/services/education/home-tutor.webp" },
      { name: "Online Tutor", image: "/images/services/education/online-tutor.webp" },
      { name: "Spoken English Classes", image: "/images/services/education/spoken-english-classes.webp" },
      { name: "Computer Classes", image: "/images/services/education/computer-classes.webp" },
      { name: "Music Classes", image: "/images/services/education/music-classes.webp" },
      { name: "Dance Classes", image: "/images/services/education/dance-classes.webp" }
    ],
  },

  // ✈ TOURS & TRAVEL
  {
    category: "Tours & Travel",
    slug: "travel",
    services: [
      { name: "Holiday Package Booking", image: "/images/services/travel/holiday-package-booking.webp" },
      { name: "Flight Booking Assistance", image: "/images/services/travel/flight-booking-assistance.webp" },
      { name: "Hotel Booking Assistance", image: "/images/services/travel/hotel-booking-assistance.webp" },
      { name: "Local Tour Guide", image: "/images/services/travel/local-tour-guide.webp" },
      { name: "Car Rental Service", image: "/images/services/travel/car-rental-service.webp" },
      { name: "Visa Assistance", image: "/images/services/travel/visa-assistance.webp" }
    ],
  },

  // 📑 LEGAL & DOCUMENTATION SERVICES
  {
    category: "Legal & Documentation Services",
    slug: "legal",
    services: [
      { name: "PAN Card Assistance", image: "/images/services/legal/pan-card-assistance.webp" },
      { name: "Aadhar Update Service", image: "/images/services/legal/aadhar-update-service.webp" },
      { name: "GST Registration", image: "/images/services/legal/gst-registration.webp" },
      { name: "Company Registration", image: "/images/services/legal/company-registration.webp" },
      { name: "Rental Agreement Drafting", image: "/images/services/legal/rental-agreement-drafting.webp" },
      { name: "Legal Consultation", image: "/images/services/legal/legal-consultation.webp" }
    ],
  },

  // 🔧 OTHER SERVICES
  {
    category: "Other Services",
    slug: "other",
    services: [
      { name: "Car Wash at Home", image: "/images/services/other/car-wash-at-home.webp" },
      { name: "Bike Service at Home", image: "/images/services/other/bike-service-at-home.webp" },
      { name: "Pet Grooming", image: "/images/services/other/pet-grooming.webp" },
      { name: "Babysitting", image: "/images/services/other/babysitting.webp" },
      { name: "Elder Care", image: "/images/services/other/elder-care.webp" },
      { name: "Fitness Trainer at Home", image: "/images/services/other/fitness-trainer-at-home.webp" },
      { name: "Solar Panel Installation", image: "/images/services/other/solar-panel-installation.webp" },
      { name: "EV Charger Installation", image: "/images/services/other/ev-charger-installation.webp" }
    ],
  },
];